import { routes } from "@/lib/constants";
import { philosopher } from "@/lib/fonts";
import { Link } from "react-router-dom";
import * as React from "react";

type SignupLayoutProps = {
  children: React.ReactNode;
  type: "customer" | "seller";
};

const SignupLayout: React.FC<SignupLayoutProps> = ({ children, type }) => {
  return (
    <div>
      <h1
        className={`text-center text-secondary text-3xl font-semibold ${philosopher.className} mb-3`}
      >
        <span>Sign</span>
        <span className="text-primary">Up</span>
      </h1>
      <p className="text-[#6f6f6f] text-center text-sm mt-2 mb-10">
        {type === "seller"
          ? "Step into the Bohra marketplace as a seller"
          : "Join the Bohra marketplace revolution today!"}
      </p>

      {children}
      {/* <div className="flex items-center gap-2">
        <div className="flex-grow border-t border-gray-300" />
        <span className="text-destructive text-xs">OR</span>
        <div className="flex-grow border-t border-gray-300" />
      </div> */}
      {type === "customer" && (
        <>
          {/* <p className="text-sm text-[#000] text-center font-semibold mt-2">
            Sign up as{" "}
            <Link
              to={routes.seller.signup}
              className="text-primary underline"
            >
              Seller
            </Link>
          </p> */}
          <p className="text-sm text-black text-center font-semibold pb-10 mt-2">
            Already have an account?{" "}
            <Link to={routes.auth.login} className="text-primary underline">
              Sign in
            </Link>
          </p>
        </>
      )}
    </div>
  );
};

export default SignupLayout;
